<!-- vip营期预约 -->
<template>
  <div class="reserve">
    <AppNavbar
      v-if="showNavBar"
      :placeholder="true"
      :options="options"
      :zIndex="999"
      :title="title"
    >
    </AppNavbar>
    <div class="content" v-if="cardInfo">
      <div class="title">请选择营养师点评服务开始日期</div>
      <div class="time-scorll">
        <div class="time-list">
          <div
            class="time-item"
            :class="{
              'item-disabled': !item.state,
              'item-active': curIndex == index
            }"
            v-for="(item, index) in courseList"
            :key="index"
            @click="bindClick(item, index)"
          >
            <span>{{ item.date }} {{ item.week }}</span
            ><span class="not-open" v-if="!item.state">暂未开放</span>
          </div>
        </div>
        <div class="not-data" v-if="!courseList.length">当前暂无可预约时间</div>
      </div>
      <div
        class="btn"
        @click="bindReserve"
        :class="{ 'btn-disabled': curIndex == -1 }"
        >预约</div
      >
    </div>
    <ReserveToast
      v-if="show"
      @close="bindClose"
      :sDate="toastData.s_date"
      :eDate="toastData.e_date"
      @consult="bindAddCustomer"
    ></ReserveToast>
    <van-popup v-model="showPopup" :close-on-click-overlay="false">
      <div class="popup-image-content">
        <img
          class="popup-image"
          src="https://btw-common-data-oss.betterwestar.com/btw-admin/resource/e29ea8c2bc6ccc74d39818936fa976cf_wh=1120_752.png"
          alt=""
        />
        <div class="close-btn" @click="showPopup = false"></div>
        <div class="close iconfont icon-cha" @click="showPopup = false"></div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
import ReserveToast from './components/reserve-toast.vue'
import { bindConsultCoach } from './components/data.js'
export default {
  components: {
    AppNavbar,
    ReserveToast
  },
  data() {
    return {
      options: {
        barBackgroundColor: 'transparent',
        color: 'rgba(0,0,0.8)'
      },
      showPopup: false,
      cardInfo: null,
      showNavBar: true,
      toastData: {},
      title: '预约餐卡点评',
      curIndex: -1,
      show: false,
      courseList: [],
      isFillQue: 0, //是否填写问卷
      vid: 0, //会员卡id
      reserveTime: '', //预约时间
      type: '', //vipid
      consultData: [
        {
          name: '周卡',
          type_id: 4,
          consultUrl:
            '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252Fcddde0d49a4624cad99671a09273d6f8.png'
        },
        {
          name: '月卡',
          type_id: 1,
          consultUrl:
            '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252Fb801b1cd3293c906a2f874b99c004f52.webp'
        },
        {
          name: '年卡',
          type_id: 3,
          consultUrl:
            '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F646e460be06c10928cdfd4a6da88757a.webp'
        }
      ]
    }
  },
  created() {
    this.getVipInfo()
    this.init()
  },
  mounted() {
    window.addEventListener('pageshow', this.bindPageShow)
  },
  beforeDestroy() {
    window.removeEventListener('pageshow', this.bindPageShow)
  },
  methods: {
    getVipInfo() {
      this.$http
        .getBaseApp('api/v3/WeplusData/getUserWeplusIdentify', {})
        .then((res) => {
          res = res.data
          this.cardInfo = res.data
        })
    },
    init() {
      let id = this.$route.query.vid
      id && (this.vid = id)
      this.type = this.$route.query.type
      this.getCourseList()
      let isFillQue = this.$http._getCookie('isFillQues')
      if (isFillQue == 1) {
        this.isFillQue = 1
        this.reserveTime = localStorage.getItem('reserveTime')
        this.bindSubmit()
        this.$http._delCookie('isFillQues')
      }
    },
    bindPageShow() {
      this.init()
    },
    //跳转客服
    bindAddCustomer() {
      let info = this.cardInfo?.weplus_info
      if (info && [1, 3, 4].includes(info.type_id)) {
        let consultObj = this.consultData.find((item) => {
          return item.type_id == info.type_id
        })
        if (consultObj.consultUrl) {
          this.$betterwe.onAppPageUrlRoute(consultObj.consultUrl)
        }
      } else {
        bindConsultCoach(this.type)
      }
    },
    bindClose() {
      this.show = false
    },
    getCourseList() {
      this.$http
        .postApp('api/v1/MealCardAppointment/appointmentList', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.courseList = this.dealData(res.data)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    dealData(list) {
      let week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      list.map((item) => {
        let time = item.date.replace(/-/g, '/')
        item.week = week[new Date(time).getDay()]
      })
      return list
    },
    getTimeClass(item) {
      return ''
    },
    bindClick(item, index) {
      if (item.state) {
        this.curIndex = index
        this.reserveTime = item.date
        localStorage.setItem('reserveTime', item.date)
      }
    },
    bindReserve() {
      if (this.curIndex == -1) {
        this.$toast('请选择预约日期')
        return
      }
      this.$dialog
        .confirm({
          title: '提示',
          message: '是否确认预约？'
        })
        .then(() => {
          this.bindSubmit()
        })
        .catch(() => {
          // on cancel
        })
    },
    bindSubmit() {
      let params = {
        date: this.reserveTime,
        mc_id: this.vid,
        is_fill_que: this.isFillQue
      }
      this.$http
        .postApp('api/v1/MealCardAppointment/appointment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.show = true
            res.data.s_date =
              res.data.s_date.slice(5, 7) +
              '月' +
              res.data.s_date.slice(8, 10) +
              '日'
            res.data.e_date =
              res.data.e_date.slice(5, 7) +
              '月' +
              res.data.e_date.slice(8, 10) +
              '日'
            this.toastData = res.data
          } else if (res.code == 10086) {
            //未填写入营问卷
            this.$dialog
              .confirm({
                title: '提示',
                message: '您还没有填写入营问卷,是否去填写?'
              })
              .then(() => {
                this.setAppTitle()
                location.href =
                  res.msg +
                  '&sfrom=campReserve' +
                  '&vid=' +
                  this.vid +
                  '&reserveTime=' +
                  this.reserveTime
              })
              .catch(() => {
                // on cancel
              })
          } else if (res.code == 10009) {
            this.showPopup = true
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    setAppTitle() {
      this.$betterwe.initWebViewUIConfig({ title: '' })
      this.showNavBar = false
    }
  }
}
</script>
<style lang="scss" scoped>
.reserve {
  height: 100vh;
  background-color: #f9f9f9;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7e363653267d94e22981914bd4f0ac92.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center top;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  ::v-deep .van-popup {
    background: transparent;
  }
  .popup-image-content {
    position: relative;
    .close-btn {
      width: 238px;
      height: 44px;
      position: absolute;
      left: 50%;
      bottom: 65px;
      transform: translate(-50%, 0%);
    }
    .popup-image {
      width: 280px;
      border-radius: 8px;
      overflow: hidden;
    }
    .close {
      color: #fff;
      font-size: 12px;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      border: 1px solid #fff;
      margin: 26px auto 0px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .content {
    margin: 32px auto 45px;
    width: 343px;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    box-sizing: border-box;
    padding: 20px 20px 24px;
    background: #ffffff;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .title {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 24px;
      margin-bottom: 18px;
    }

    .time-scorll {
      flex: 1;
      flex-shrink: 0;
      overflow: scroll;
    }

    .time-list {
      display: inline-flex;
      align-items: stretch;
      flex-direction: column;

      .time-item {
        box-sizing: border-box;
        background: #f9f9f9;
        height: 42px;
        border-radius: 6px;
        border: 1px solid rgba(0, 0, 0, 0.3);
        margin-bottom: 10px;
        padding: 11px 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
        line-height: 20px;

        .not-open {
          margin-left: 16px;
        }
      }

      .item-active {
        color: #5c311f;
        background: rgba(254, 225, 195, 0.4);
        border: 2px solid rgba(255, 207, 162, 1);
      }

      .item-disabled {
        border: 1px solid rgba(0, 0, 0, 0.1);
        color: rgba(0, 0, 0, 0.3);
      }

      .time-item:last-child {
        margin-bottom: 0;
      }
    }

    .btn {
      text-align: center;
      height: 44px;
      background: linear-gradient(180deg, #fee1c3 0%, #ffcfa2 100%);
      border-radius: 8px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #5c311f;
      line-height: 44px;
      margin-top: 30px;
    }

    .btn-disabled {
      color: #fff;
      background: linear-gradient(90deg, #babbc5 0%, #9fa0a8 100%);
    }
  }

  .toast {
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    width: 295px;
    margin: 0 auto;
    padding: 70px 20px 20px;
    background: #ffffff;
    border-radius: 12px;

    .close {
      width: 24px;
      height: 24px;
      box-sizing: border-box;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      border: 1px solid #fff;
      position: absolute;
      left: 50%;
      bottom: -40px;
      transform: translate(-50%, 0%);
    }

    .toast-image {
      position: absolute;
      left: 0%;
      top: -29px;
      width: 100%;
      height: 82px;
      object-fit: contain;
    }

    .title {
      margin-bottom: 12px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 26px;
    }

    .time {
      margin-bottom: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.8);
      line-height: 22px;
    }

    .bold {
      font-weight: 600;
    }

    .desc {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.8);
      line-height: 22px;
      margin-bottom: 36px;
    }

    .consult {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 14px;
      margin-bottom: 8px;

      .icon {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }

    .btn {
      height: 44px;
      background: linear-gradient(180deg, #fee1c3 0%, #ffcfa2 100%);
      border-radius: 12px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #5c311f;
      line-height: 44px;
    }
  }

  .not-data {
    text-align: center;
    color: rgba(0, 0, 0, 0.5);
  }
}
</style>
